import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchAssetsThunk } from "./assets.actions";

export const fetchAssets = createAsyncThunk(
  "assets/fetchAssets",
  fetchAssetsThunk
);

const initialState: any = {
  about: "",
  private_policy: "",
  terms_and_condition: "",
  faq: "",
  is_fetch: false,
};
// https://infocomp.ba/assets/politika_privatnosti.html
// https://infocomp.ba/assets/uslovi_i_odredbe.html
// https://infocomp.ba/assets/najcesca_pitanja.html
// https://infocomp.ba/assets/o_nama.html
const AssetsSlice = createSlice({
  name: "assets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssets.fulfilled, (state, { payload }) => {
        if (payload.asset === "o_nama") {
          return {
            ...state,
            is_fetch: true,
            about: payload.data,
          };
        } else if (payload.asset === "politika_privatnosti") {
          return {
            ...state,
            is_fetch: true,
            private_policy: payload.data,
          };
        } else if (payload.asset === "uslovi_i_odredbe") {
          return {
            ...state,
            is_fetch: true,
            terms_and_condition: payload.data,
          };
        } else if (payload.asset === "najcesca_pitanja") {
          return {
            ...state,
            is_fetch: true,
            faq: payload.data,
          };
        }
      })
      .addCase(fetchAssets.pending, (state) => {
        return {
          ...state,
          is_fetch: false,
        };
      })
      .addCase(fetchAssets.rejected, (state) => {
        return {
          ...state,
          is_fetch: false,
        };
      });
  },
});

export default AssetsSlice.reducer;
